import React from 'react'

const WorkTwoImageRow = (props) =>{


    //console.log("WorkTowImageRow",props);




      return (<div className="content-row two-images">
                   <div className="left">
                     <img src={props.item.left.image.url} alt="" />
                     <div className={"caption "+( props.item.left.caption.colour)}>
                        <div className="inner" dangerouslySetInnerHTML={{__html:props.item.left.caption.caption_text}} />
                      </div>
                   </div>
                   <div className="right">
                     <img src={props.item.right.image.url} alt="" />
                     <div className={"caption "+( props.item.right.caption.colour)}>
                        <div className="inner" dangerouslySetInnerHTML={{__html:props.item.right.caption.caption_text}} />
                      </div>
                   </div>
                </div>)



}

export default WorkTwoImageRow;


// WEBPACK FOOTER //
// ./src/modules/work/WorkTwoImageRow.js